import {HoistModel, managed, TaskObserver} from '@xh/hoist/core';
import {action, observable} from '@xh/hoist/mobx';
import {Security} from '../../../../data/DataTypes';
import {TabContainerModel} from '@xh/hoist/cmp/tab';
import {Icon} from '@xh/hoist/icon';
import {div} from '@xh/hoist/cmp/layout';
import {securityEdit} from './security/SecurityEdit';
import {SecurityEditModel} from './security/SecurityEditModel';
import {companyEdit} from './company/ComponyEdit';
import {CompanyEditModel} from './company/CompanyEditModel';
import {bookSectionIcon} from '../../../../../core/Icons';

export class SecurityEditDialogModel extends HoistModel {
    apiTask = TaskObserver.trackLast();
    @observable accessor isOpen = false;
    @observable accessor security: Security;
    @managed tabModel = this.createTabModel();
    @managed securityModel = new SecurityEditModel();
    @managed companyModel = new CompanyEditModel();
    private resolver: (boolean) => void;

    @action
    openAsync(security: Security): Promise<boolean> {
        this.isOpen = true;
        this.security = security;

        this.securityModel.load(security?.id);
        this.companyModel.load(security?.id);

        return new Promise(r => (this.resolver = r));
    }

    @action
    close() {
        this.isOpen = false;
        this.resolver(false);
    }

    private createTabModel(): TabContainerModel {
        return new TabContainerModel({
            tabs: [
                {
                    id: 'security',
                    icon: Icon.infoCircle(),
                    content: securityEdit()
                },
                {
                    id: 'company',
                    icon: Icon.office({prefix: 'fal'}),
                    content: companyEdit()
                },
                {
                    id: 'financials',
                    icon: bookSectionIcon(),
                    content: div('financials')
                }
            ]
        });
    }
}
